import { noop } from '../noop';
import { doPolling } from '../polling';
import { id as appIds } from './init';
var loaded = false;
export default (function (callback) {
  var sendGA = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      delay = _ref.delay,
      doNotShowDays = _ref.doNotShowDays;

  if (loaded) {
    return;
  }

  loaded = true;
  var initInterval = setInterval(function () {
    if (window.google && window.google.accounts) {
      clearInterval(initInterval);
      var oneTapApi = window.google.accounts.id;
      var oneTapShowed = localStorage.getItem('oneTapShowed');
      var nowTime = Date.now();

      if (!oneTapShowed || Number(oneTapShowed) + doNotShowDays * 86400000 <= nowTime) {
        // 86400000 = time on ms in one day
        setTimeout(function () {
          if (window.lwapi && !window.lwapi.isAuth() && !window.lwapi.isOpen()) {
            oneTapApi.initialize({
              callback: callback,
              client_id: appIds.gp
            });

            try {
              localStorage.setItem('oneTapShowed', nowTime);
            } catch (error) {
              if (error.name === 'QuotaExceededError') {// не обрабатываем
              } else {
                throw error;
              }
            }

            oneTapApi.prompt(function (notification) {
              if (notification.isDisplayed()) {
                doPolling(function () {
                  return sendGA({
                    eventActionPath: ['onShowOneTap']
                  });
                }, function () {
                  return typeof window.dataLayer !== 'undefined';
                }, {
                  timeout: 10000
                });
              }
            });
          }
        }, delay || 0);
      }
    }
  }, 100);
});